(function () {
  'use strict';

  angular
      .module('irricrops')
      .factory('dialogMultiInput', ["$mdDialog", function ($mdDialog) {
        var r                = {};

        var controllerDialog = ["$mdDialog", function ($mdDialog) {
          var vm  = this;

          vm.hide = function () {
            $mdDialog.hide({});
          };

          vm.cancel = function () {
            $mdDialog.cancel();
          };

          vm.save = function () {
            //isValid??
            var data = getData();
            $mdDialog.hide(data);
          };

          function getData() {
            var data = {};
            if(vm.options.type == 'riego'){
              switch (vm.options.metric){
                case 'milimetros':
                  if(vm.mm !== undefined){
                    data.milimetros = parseFloat(vm.mm);
                  }else{
                    data.milimetros = 0;
                  }
                  break;
                case 'horas':
                  if(vm.horas !== undefined){
                    data.horas   = parseFloat(vm.horas);
                  }else{
                    data.horas = 0;
                  }
                  if(vm.minutos !== undefined){
                    data.minutos = parseFloat(vm.minutos);
                  }else{
                    data.minutos = 0;
                  }
              }
              if(vm.options.conCaudalimetro){
                if(vm.volumen !== undefined){
                  data.volumen = parseFloat(vm.volumen);
                }else{
                  data.volumen = 0;
                }
              }
            }
            if(vm.options.type == 'scholander'){
              if(vm.scholander !== undefined){
                data.scholander = parseFloat(vm.scholander);
              }else{
                data.scholander = 0;
              }
            }
            if(vm.options.type == 'calibraje'){
              if(vm.calibre !== undefined){
                data.calibre = parseFloat(vm.calibre );
              }else{
                data.calibre = 0;
              }
              if(vm.gramos !== undefined){
                data.gramos = parseFloat(vm.gramos );
              }else{
                data.gramos = 0;
              }
            }
            if(vm.options.type == 'porometro'){
              if(vm.porometro !== undefined){
                data.porometro = parseFloat(vm.porometro );
              }else{
                data.porometro = 0;
              }
            }
            return data;
          }


        }];

        r.show = function (ev, options) {
          var prom = $mdDialog.show({
            controller          : controllerDialog,
            controllerAs        : 'd',
            templateUrl         : 'components/vinedo/newtimeline/dialog/dialogMultiInput.html',
            parent              : $(document.body),
            targetEvent         : ev,
            clickOutsideToClose : true,
            bindToController    : true,
            locals              : {
              options : options
            }
          });
          prom.then(function (answer) {
            //$scope.status = 'You said the information was "' + answer + '".';
          }, function () {
            //$scope.status = 'You cancelled the dialog.';
          });
          return prom;
        };

        return r;

      }]);


})();
